import React, { useEffect, useRef, FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import useScrollToBottom from '@sv-support-sdk/utils/src/hooks/useScrollToBottom';

import type { OutletContextType } from './types/outlet';
import PageContent from './components/Layout/Page/PageContent';
import Modals from './components/Modals';
import Notifications from './components/Feedback/Notifications';

const MainAppContent = () => {
  const location = useLocation();
  const node = useRef<HTMLDivElement>(null);
  const scrollToBottom = useScrollToBottom(node);

  useEffect(() => {
    if (node.current) {
      const contentInner = node.current.querySelector('div#contentInner');
      contentInner?.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <PageContent ref={node}>
      <Outlet context={{ scrollToBottom } satisfies OutletContextType} />
      <Modals />
      <Notifications />
    </PageContent>
  );
};

export default MainAppContent;
